module.exports = __webpack_public_path__ + "img/user2.a3193048.png";